import { Component, OnInit, Inject,ViewChild } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {TranslateService} from '@ngx-translate/core';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import Swal from 'sweetalert2';
import { lang_perfiles } from 'app/idiomas/i18n/perfiles/perfiles.lang';
@Component({
  selector: 'app-infra-struct',
  templateUrl: './infra-struct.component.html',
  styleUrls: ['./infra-struct.component.scss']
})
export class InfraStructComponent implements OnInit {
  infraEstruct=false;
  subDominio="";
  regexEmpresa = new RegExp("^[a-z0-9]*$");
  caracteresNoPermitidosEmpresa=false;
  constructor(
  @Inject(MAT_DIALOG_DATA) public datos: any,
  public dialogRef: MatDialogRef<InfraStructComponent>,
  private dialog: MatDialog,
  private translateSrv: TranslateService,
  private _fuseTranslationLoaderService: FuseTranslationLoaderService,) {
    lang_perfiles.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
  }

  ngOnInit(): void {
    console.log("datos",this.datos);

  }

  validacionSubDominio(even:any){
    console.log(even.target.value);
    console.log("this.subDominio",this.subDominio);
    if(this.validarCadenaEmpresa(even.target.value)){
    console.log("esta bien ");
    this.caracteresNoPermitidosEmpresa=false
    } else{
      console.log("nel esta mal");
      this.caracteresNoPermitidosEmpresa=true;
    }
  }

  validarCadenaEmpresa(cadena:any){
    return this.regexEmpresa.test(cadena);
  }

  saveSubDominio(){
    console.log("se guardo");
    if (this.infraEstruct==true) {
      if (this.subDominio=="") {
        Swal.fire({
          icon: 'warning',
          title: this.translateSrv.instant('MODAL_CONSULT_INFRAESTRU.MODA_IMPORT_SUBDOM'),
          confirmButtonText: this.translateSrv.instant('ALERTS.OK'),
          confirmButtonColor: '#e40601'
        });
      }else{
        this.dialogRef.close({
          infraEstruct: this.infraEstruct,
          subDominio:this.subDominio,
        });
      }
    }else{
      this.dialogRef.close({
        infraEstruct: this.infraEstruct,
        subDominio:this.subDominio,
      });
    }
  }
}
